import toast from '@components/Common/Toast.js';
import { STATICS_DIR } from '@constants/global.js';
import { UIImage } from '@ui';
const types = {
  src: 'src',
  name: 'name',
  email: 'email',
};

export class Avatar extends UIImage {
  constructor({ src, name, email } = types) {
    super(src ?? `${STATICS_DIR}images/icons/user.svg`);
    this.setClass('w-8 h-8 rounded-full');
    this.setStyle('border', ['1px solid var(--subtle-text)']);
    this.setStyle('background-color', ['var(--app-soft-gray)']);
    this.setStyle('margin-right', ['-0.5rem']);

    if (name.length > 0) {
      this.setTitle(name);
    } else if (email.length > 0) {
      this.setTitle(email);
    }

    this.onClick(event => {
      event.stopPropagation();
      if (email) {
        navigator.clipboard.writeText(email);
        toast.info(
          i18next.t('pages.projects.toast.email_copied.title'),
          i18next.t('pages.projects.toast.email_copied.description'),
        );
      }
    });
  }
}
